const debounce = <T>(fn: Function) => {
  let pending: Promise<T> | undefined = undefined
  return () => {
    if (pending === undefined) {
      pending = new Promise<T>(resolve => {
        Promise.resolve().then(() => {
          pending = undefined
          resolve(fn())
        })
      })
    }

    return pending
  }
}

export default debounce
